import React from 'react';
import PropTypes from 'prop-types';

import './CheckboxField.less';

export function CheckboxField({ checked, disabled, label, name, onChange }) {
  return (
    <div className="CheckboxField">
      <input
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        name={name}
        id={name}
        type="checkbox"
      />
      <label
        htmlFor={name}
      >
        {label}
      </label>
    </div>
  );
}

CheckboxField.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

CheckboxField.defaultProps = {
  checked: false,
  disabled: false,
};

export default CheckboxField;
